<nz-spin
  [nzTip]="'LOADING' | translate"
></nz-spin>
